// @ts-nocheck -- staged migration: add explicit types before removing this directive.
export const katakana = [

  {
    symbol: " ",
    romaji: "space",
  },
  {
    symbol: "、",
    romaji: ",",
  },
  {
    symbol: "。",
    romaji: ".",
  },
  {
    symbol: "？",
    romaji: "?",
  },
  {
    symbol: "！",
    romaji: "!",
  },
  {
    symbol: "ー",
    romaji: "-",
  },
  {
    symbol: "・",
    romaji: "dot",
  },
  {
    symbol: "ア",
    romaji: "a",
  },
  { symbol: "ァ", romaji: "small-a" },
  {
    symbol: "イ",
    romaji: "i",
  },
  { symbol: "ィ", romaji: "small-i" },
  {
    symbol: "ウ",
    romaji: "u",
  },
  { symbol: "ゥ", romaji: "small-u" },
  {
    symbol: "エ",
    romaji: "e",
  },
  { symbol: "ェ", romaji: "small-e" },
  {
    symbol: "オ",
    romaji: "o",
  },
  { symbol: "ォ", romaji: "small-o" },
  {
    symbol: "カ",
    romaji: "ka",
  },
  { symbol: "ヵ", romaji: "small-ka" },
  {
    symbol: "キ",
    romaji: "ki",
  },
  {
    symbol: "ク",
    romaji: "ku",
  },
  {
    symbol: "ケ",
    romaji: "ke",
  },
  { symbol: "ヶ", romaji: "small-ke" },
  {
    symbol: "コ",
    romaji: "ko",
  },
  {
    symbol: "ガ",
    romaji: "ga",
  },
  {
    symbol: "ギ",
    romaji: "gi",
  },
  {
    symbol: "グ",
    romaji: "gu",
  },
  {
    symbol: "ゲ",
    romaji: "ge",
  },
  {
    symbol: "ゴ",
    romaji: "go",
  },
  {
    symbol: "サ",
    romaji: "sa",
  },
  { symbol: "シ", romaji: "shi" },
  {
    symbol: "ス",
    romaji: "su",
  },
  {
    symbol: "セ",
    romaji: "se",
  },
  {
    symbol: "ソ",
    romaji: "so",
  },
  {
    symbol: "ザ",
    romaji: "za",
  },
  { symbol: "ジ", romaji: "ji" },
  {
    symbol: "ズ",
    romaji: "zu",
  },
  {
    symbol: "ゼ",
    romaji: "ze",
  },
  {
    symbol: "ゾ",
    romaji: "zo",
  },
  {
    symbol: "タ",
    romaji: "ta",
  },
  { symbol: "チ", romaji: "chi" },
  {
    symbol: "ツ",
    romaji: "tsu",
  },
  { symbol: "ッ", romaji: "small-tsu" },
  {
    symbol: "テ",
    romaji: "te",
  },
  {
    symbol: "ト",
    romaji: "to",
  },
  {
    symbol: "ダ",
    romaji: "da",
  },
  {
    symbol: "ヂ",
    romaji: "di",
  },
  {
    symbol: "ヅ",
    romaji: "du",
  },
  { symbol: "デ", romaji: "de" },
  { symbol: "ド", romaji: "do" },
  {
    symbol: "ン",
    romaji: "n",
  },
  {
    symbol: "ナ",
    romaji: "na",
  },
  {
    symbol: "ニ",
    romaji: "ni",
  },
  {
    symbol: "ヌ",
    romaji: "nu",
  },
  {
    symbol: "ネ",
    romaji: "ne",
  },
  {
    symbol: "ノ",
    romaji: "no",
  },
  {
    symbol: "ハ",
    romaji: "ha",
  },
  {
    symbol: "ヒ",
    romaji: "hi",
  },
  { symbol: "フ", romaji: "fu" },
  {
    symbol: "ヘ",
    romaji: "he",
  },
  {
    symbol: "ホ",
    romaji: "ho",
  },
  {
    symbol: "バ",
    romaji: "ba",
  },
  {
    symbol: "ビ",
    romaji: "bi",
  },
  {
    symbol: "ブ",
    romaji: "bu",
  },
  {
    symbol: "ベ",
    romaji: "be",
  },
  {
    symbol: "ボ",
    romaji: "bo",
  },
  {
    symbol: "パ",
    romaji: "pa",
  },
  {
    symbol: "ピ",
    romaji: "pi",
  },
  {
    symbol: "プ",
    romaji: "pu",
  },
  {
    symbol: "ペ",
    romaji: "pe",
  },
  {
    symbol: "ポ",
    romaji: "po",
  },
  {
    symbol: "マ",
    romaji: "ma",
  },
  {
    symbol: "ミ",
    romaji: "mi",
  },
  {
    symbol: "ム",
    romaji: "mu",
  },
  {
    symbol: "メ",
    romaji: "me",
  },
  {
    symbol: "モ",
    romaji: "mo",
  },
  {
    symbol: "ヤ",
    romaji: "ya",
  },
  {
    symbol: "ユ",
    romaji: "yu",
  },
  { symbol: "ヨ", romaji: "yo" },
  {
    symbol: "ラ",
    romaji: "ra",
  },
  {
    symbol: "リ",
    romaji: "ri",
  },
  {
    symbol: "ル",
    romaji: "ru",
  },
  {
    symbol: "レ",
    romaji: "re",
  },
  {
    symbol: "ロ",
    romaji: "ro",
  },
  {
    symbol: "ワ",
    romaji: "wa",
  },
  {
    symbol: "ヰ",
    romaji: "wi",
  },
  {
    symbol: "ヱ",
    romaji: "we",
  },
  {
    symbol: "ヲ",
    romaji: "wo",
  },
  { symbol: "ャ", romaji: "small-ya" },
  { symbol: "ュ", romaji: "small-yu" },
  { symbol: "ョ", romaji: "small-yo" },
  {
    symbol: "キャ",
    romaji: "kya",
  },
  {
    symbol: "キュ",
    romaji: "kyu",
  },
  {
    symbol: "キョ",
    romaji: "kyo",
  },
  {
    symbol: "シャ",
    romaji: "sha",
  },
  {
    symbol: "シュ",
    romaji: "shu",
  },
  {
    symbol: "ショ",
    romaji: "sho",
  },
  {
    symbol: "チャ",
    romaji: "cha",
  },
  {
    symbol: "チュ",
    romaji: "chu",
  },
  {
    symbol: "チョ",
    romaji: "cho",
  },
  {
    symbol: "ニャ",
    romaji: "nya",
  },
  {
    symbol: "ニュ",
    romaji: "nyu",
  },
  {
    symbol: "ニョ",
    romaji: "nyo",
  },
  {
    symbol: "ヒャ",
    romaji: "hya",
  },
  {
    symbol: "ヒュ",
    romaji: "hyu",
  },
  {
    symbol: "ヒョ",
    romaji: "hyo",
  },
  {
    symbol: "ミャ",
    romaji: "mya",
  },
  {
    symbol: "ミュ",
    romaji: "myu",
  },
  {
    symbol: "ミョ",
    romaji: "myo",
  },
  {
    symbol: "リャ",
    romaji: "rya",
  },
  {
    symbol: "リュ",
    romaji: "ryu",
  },
  {
    symbol: "リョ",
    romaji: "ryo",
  },
  {
    symbol: "ギャ",
    romaji: "gya",
  },
  {
    symbol: "ギュ",
    romaji: "gyu",
  },
  {
    symbol: "ギョ",
    romaji: "gyo",
  },
  {
    symbol: "ジャ",
    romaji: "ja",
  },
  {
    symbol: "ジュ",
    romaji: "ju",
  },
  {
    symbol: "ジョ",
    romaji: "jo",
  },
  {
    symbol: "ヂャ",
    romaji: "ja",
  },
  {
    symbol: "ヂュ",
    romaji: "ju",
  },
  {
    symbol: "ヂョ",
    romaji: "jo",
  },
  {
    symbol: "ビャ",
    romaji: "bya",
  },
  {
    symbol: "ビュ",
    romaji: "byu",
  },
  {
    symbol: "ビョ",
    romaji: "byo",
  },
  {
    symbol: "ピャ",
    romaji: "pya",
  },
  {
    symbol: "ピュ",
    romaji: "pyu",
  },
  {
    symbol: "ピョ",
    romaji: "pyo",
  },
];
